import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background:'var(--bg2)', borderTop:'1px solid var(--border)', padding:'48px 0 28px', marginTop:80 }}>
      <div className="container" style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:20, textAlign:'center' }}>
        <Link to="/" style={{ fontFamily:'var(--font-d)', fontSize:'1.6rem', fontWeight:700, color:'var(--text)' }}>
          Book<span style={{ color:'var(--gold)' }}>Pub</span>
        </Link>
        <p style={{ color:'var(--text3)', fontSize:'0.88rem', maxWidth:400 }}>
          A home for stories that linger. New chapters every week.
        </p>
        <div style={{ display:'flex', gap:28 }}>
          {[['Browse', '/books'], ['Sign Up', '/register'], ['Login', '/login']].map(([l, t]) => (
            <Link key={t} to={t} style={{ color:'var(--text3)', fontSize:'0.83rem', letterSpacing:'0.05em', textTransform:'uppercase', fontWeight:700, transition:'color 0.2s' }}
              onMouseEnter={e => e.target.style.color='var(--gold)'}
              onMouseLeave={e => e.target.style.color='var(--text3)'}
            >{l}</Link>
          ))}
        </div>
        <p style={{ color:'var(--text3)', fontSize:'0.75rem', opacity:0.6, marginTop:8 }}>
          © {new Date().getFullYear()} BookPub. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
